export default "__VITE_ASSET__Bd9SQ8Fg__"